import { api } from "@api/api";
import { ProductPlan } from "@modules/defaultProducts/types/productPlan";
import { ProductPlanFormValues } from "@modules/defaultProducts/types/productPlan";

export async function updateProductPlanService(id: string, data: Partial<ProductPlanFormValues>): Promise<ProductPlan> {
  const { data: productPlan } = await api.patch<ProductPlan>(`v1/default_plan_admin/${id}/`, data);

  return productPlan;
}
